import { Box, CircularProgress, IconButton, Stack, Typography } from '@mui/material'
import React, { ReactNode } from 'react'
import { IoMdArrowRoundBack, IoMdClose } from 'react-icons/io'
import { HiOutlineRefresh } from 'react-icons/hi'

interface IProps {
  title?: string
  onActionClick?: { type: 'close' | 'back'; action: () => void }
  refreshAction?: () => void
  isRefreshing?: boolean
  leftItem?: ReactNode
}

export const Titlebar = ({
  title,
  onActionClick,
  refreshAction,
  isRefreshing,
  leftItem,
}: IProps) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      {onActionClick ? (
        <IconButton
          sx={{ width: 40, marginLeft: 1 }}
          color="primary"
          onClick={onActionClick.action}
        >
          {onActionClick.type === 'back' ? <IoMdArrowRoundBack /> : <IoMdClose />}
        </IconButton>
      ) : (
        <Box width={40} />
      )}
      <Stack alignItems="center" justifyContent="center">
        <Typography variant="h6">{title}</Typography>
      </Stack>

      {refreshAction ? (
        <Box width={40} height={20} display="flex" justifyContent="center" alignItems="center">
          {isRefreshing && <CircularProgress size={20} thickness={5} />}
          {!isRefreshing && (
            <IconButton color="primary" onClick={refreshAction}>
              <HiOutlineRefresh size={20} />
            </IconButton>
          )}
        </Box>
      ) : leftItem ? (
        leftItem
      ) : (
        <Box width={40} />
      )}
    </Stack>
  )
}
